import styled, { css } from 'styled-components';
import { mediaMaxWidth, media } from 'common/styles/breakpoints';
import {
    BACKGROUND_PROPERTIES,
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

const SIDE_BY_SIDE_LAYOUT = css`
    justify-content: space-between;
`;

const STACKED_LAYOUT = css`
    text-align: center;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
`;

export const HeaderStyles = styled.header`
    padding: 2rem;
    display: flex;
    gap: 2rem;
    align-items: flex-start;

    ${media.large`
        ${(props) => (props.$stacked ? STACKED_LAYOUT : SIDE_BY_SIDE_LAYOUT)}
    `}

    ${mediaMaxWidth.large`
        ${STACKED_LAYOUT}
    `}

    ${BACKGROUND_PROPERTIES}
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
